import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import { Filter } from '../../../helpers/tableview';
import { AuthService } from '../../login/auth.service';
import { environment } from '../../../../environments/environment';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class DataMatchingService {

    private headers: Headers;
    private url = environment.apiUrl;

    constructor(private http: Http, private authService: AuthService) {
      this.headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authService.getAuth().token})
    }

    public getFiles(filter: Filter): Promise<any> {
        return this.http
          .post(this.url+'/admin/data-matching', filter, {headers: this.headers})
          .toPromise()
          .then(res => { return {items: res.json().files, total: res.json().total}})
          .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
      console.error('An error occurred', error);
      return Promise.reject(error.json().error.message || error);
    }

    upload(queue: any[]): Promise<boolean> {
      let formData: FormData = new FormData();

      queue.forEach(item => {
          formData.append("files[]", item._file, item._file.name);
      });

      return Promise.resolve().then(()=>{
          var headers = new Headers({'Authorization': 'Bearer '+this.authService.getAuth().token})

          return this.http
            .post(this.url+'/admin/data-matching/upload', formData, {headers: headers})
            .toPromise()
            .then(res => res.json().result as boolean)
            .catch(this.handleError);
      });
    }

}

export enum DataMatchingStatus {
  All = 0,
  Uploading,
  Waiting,
  Success,
  Error
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/data-matching/data-matching.service.ts